import { Link, useNavigate } from "react-router-dom";
import WebLayout from "../../../layout/WebLayout";
import { useForm } from "react-hook-form";
import VendorAction from "../../../stores/actions/VendorAction";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { useState } from "react";
type FormData = {
  company_name: string;
  name: string;
  mobile: number;
  email: string;
  country: string;
  state: string;
  district: string;
  pincode: number;
  address: string;
  gst_no: string;
};
function AddVendor() {
  const dispatch = useDispatch<any>();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm<FormData>();

  const formHandleSubmit = async (data: any) => {
    setLoading(true);
    try {
      const VendorData = await dispatch(
        VendorAction.addVendor({
          company_name: data.company_name,
          name: data.name,
          mobile: data.mobile,
          email: data.email,
          country: data.country,
          state: data.state,
          district: data.district,
          pincode: data.pincode,
          address: data.address,
          gst_no: data.gst_no,
        })
      );
      if (VendorData.status === false) {
        toast.error(VendorData.msg);
        setLoading(false);
      } else {
        reset();
        navigate("/vendor-list");
        toast.success(VendorData.msg);
      }
    } catch (error) {
      setLoading(false);
    }
  };
  return (
    <WebLayout pageName={"AddVendor"}>
      <div className="content-wrapper">
        <div className="container-xxl flex-grow-1 container-p-y">
          <div className="app-ecommerce">
            <div className="d-flex flex-wrap justify-content-between align-items-center mb-2">
              <h4 className="mb-1">Add Vendor</h4>
              <Link to="/vendor-list" className="btn btn-primary btn-sm">
                <i className="bx bx-chevron-left bx-sm align-middle"></i> Back
              </Link>
            </div>
            <div className="row">
              <div className="col-12 col-lg-12">
                <div className="card mb-4">
                  <div className="card-header d-flex justify-content-between">
                    <h5 className="card-tile mb-0">Vendor information</h5>
                  </div>
                  <form onSubmit={handleSubmit(formHandleSubmit)}>
                    <div className="card-body">
                      <div className="row mb-3">
                        <div className="col">
                          <label className="form-label">Company Name</label>
                          <input
                            type="text"
                            className="form-control"
                            id="ecommerce-product-name"
                            placeholder="Enter Company Name"
                            {...register("company_name")}
                          />
                        </div>
                        <div className="col">
                          <label className="form-label">Name</label>
                          <input
                            type="text"
                            className="form-control"
                            id="ecommerce-product-name"
                            placeholder="Enter Name"
                            {...register("name")}
                          />
                        </div>
                        <div className="col">
                          <label className="form-label">Mobile No.</label>
                          <input
                            type="number"
                            className="form-control"
                            id="ecommerce-product-sku"
                            placeholder="Enter Mobile No."
                            {...register("mobile")}
                          />
                        </div>
                      </div>
                      <div className="row mb-3">
                        <div className="col">
                          <label className="form-label">Email Id</label>
                          <input
                            type="text"
                            className="form-control"
                            id="ecommerce-product-barcode"
                            placeholder="Enter Email Id"
                            {...register("email")}
                          />
                        </div>
                        <div className="col">
                          <label className="form-label">GST No</label>
                          <input
                            type="text"
                            className="form-control"
                            id="ecommerce-product-barcode"
                            placeholder="Enter GST No."
                            {...register("gst_no")}
                          />
                        </div>
                        <div className="col">
                          <label className="form-label">Country</label>
                          <input
                            type="text"
                            className="form-control"
                            id="ecommerce-product-barcode"
                            {...register("country")}
                          />
                        </div>
                      </div>

                      <div className="row mb-3">
                        <div className="col">
                          <label className="form-label">State</label>
                          <input
                            type="text"
                            className="form-control"
                            id="ecommerce-product-barcode"
                            {...register("state")}
                          />
                        </div>
                        <div className="col">
                          <label className="form-label">District</label>
                          <input
                            type="text"
                            className="form-control"
                            id="ecommerce-product-barcode"
                            placeholder="Enter District"
                            {...register("district")}
                          />
                        </div>
                        <div className="col">
                          <label className="form-label">Pincode</label>
                          <input
                            type="text"
                            className="form-control"
                            id="ecommerce-product-barcode"
                            placeholder="Enter Pincode"
                            {...register("pincode")}
                          />
                        </div>
                      </div>
                      <div className="row mb-3">
                        <div className="col">
                          <label className="form-label">Address</label>
                          <textarea
                            className="form-control"
                            {...register("address")}
                            placeholder="Enter Address"></textarea>
                        </div>
                      </div>
                      <button
                        type="submit"
                        disabled={loading}
                        className="btn btn-primary px-4">
                        {loading ? (
                          <i className={"fa fa-spinner fa-spin"}></i>
                        ) : null}
                        &nbsp; Save Vendor
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </WebLayout>
  );
}

export default AddVendor;
